import { render, staticRenderFns } from "./CeurClaimOcr.vue?vue&type=template&id=4ea5e0dc&scoped=true"
import script from "./CeurClaimOcr.vue?vue&type=script&lang=js"
export * from "./CeurClaimOcr.vue?vue&type=script&lang=js"
import style0 from "./CeurClaimOcr.vue?vue&type=style&index=0&id=4ea5e0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea5e0dc",
  null
  
)

export default component.exports